'use strict';

const filterParentModel = require('od-modules/models/accommodation_filter');

module.exports = Odigeo.Model.extend(filterParentModel).extend({
    dataUrl: Odigeo.Utils.isRequestApp('dp') ? 'accommodation/filtered' : 'accommodation/results/filtered',
    filterMetadataPath: 'accommodationFiltersMetadata.hotelNameMetadata',
    filterStatusPath: 'accommodationSearchResultsMetadata.hotelNameFilterModel',

    refreshData() {
        this.isEmptyData = false;
        this.refresh();
    },

    url() {
        return Odigeo.Settings.getProperty('serviceUrlFormatter')(this.dataUrl);
    },

    getDataRequestSettings() {
        return {
            type: 'GET',
            data: null,
            success: (response) => this.requestSuccessHandler(response),
            error: () => {},
        };
    },

    requestSuccessHandler(response) {
        Odigeo.trigger(`${this.widget.id}:onHotelNameListReceived`, response);
    },

});
